// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1uPdH","active":"downloadDropdown_active__2CtX1"};